import * as types from '../mutation-types'
import api from '@/api/comments'

// initial state
const state = {
    comments: {},
    loaded: false,
}

const getters = {
    comments: state => state.comments,
    commentsLoaded: state => state.loaded,
}

const actions = {
    getComments({ commit }, params) {
        commit(types.SET_COMMENTS_LOADED, false );
        api.getComments(params, (response) => {
            commit(types.SET_COMMENTS, response );
            commit(types.SET_COMMENTS_LOADED, true );
        })
    },
}

const mutations = {
    [types.SET_COMMENTS] (state, comments ) {
        state.comments = comments
    },
    [types.SET_COMMENTS_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}
